import { TranslatePipe } from '@ngx-translate/core';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'staffing-result-answer',
    templateUrl: 'staffing-result-answer.component.html',
    styleUrls: ['staffing-result-answer.component.scss'],
    providers: [TranslatePipe],
})
export class StaffingResultAnswerComponent {
    @Input() answer: String;
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/staffing/result/answer/staffing-result-answer.component.ts